/**
 * Wave 358 · Rollback schemas — undo executed proposals.
 * Shape documented here; ships in 358.
 */

import { z } from 'zod';
import { idSchema, isoDateTimeSchema } from './common.js';

export const RollbackDTOSchema = z.object({
  id: idSchema,
  proposalId: idSchema,
  executionId: idSchema,
  revertedAt: isoDateTimeSchema,
  reason: z.string(),
});
export type RollbackDTO = z.infer<typeof RollbackDTOSchema>;
